import {connect} from 'react-redux';
import {
  homepageTitleSelector
} from '../../../reducers';
import PageHelmet from './component';

const mapStateToProps = (state) => {
  return {
    homepageTitle: homepageTitleSelector(state),
  };
};

export default connect(mapStateToProps)(PageHelmet);



// WEBPACK FOOTER //
// ./src/component/organisms/PageHelmet/index.js